{
	"ctn": "872989200552",
	"ctvs": ["1", "2", "3"],
	"availableInCountries": ["DE", "FR", "IT"],
	"isAssigned": false,
	"_links": {
		"self": {
			"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment/a1111111-1111-1111-1111-111111111111"
		},
		"collection": {
			"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment"
		}
	}
}
